import { type ClientError } from 'graphql-request'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNotify } from '~/hooks/useNotify'

export const useNotifyOnError = () => {
  const { t } = useTranslation()
  const notify = useNotify()

  return React.useCallback(
    (data: ClientError, messageMap: Record<number, string>) => {
      if (data.response.errors === undefined) {
        return
      }
      const statusCode = data.response.errors[0].extensions.statusCode
      const defaultMessage = t('an_error_has_occurred')
      const message =
        typeof statusCode === 'number'
          ? (messageMap[statusCode] ?? defaultMessage)
          : defaultMessage
      notify({ content: message, style: 'error' })
    },
    [notify, t],
  )
}
